module.exports = require("xlsx/dist/xlsx.core.min.js");